module.exports = __webpack_public_path__ + "static/img/SPLF.b00bec1.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPLF.png
// module id = GuDl
// module chunks = 1